export const usesg = [
  {
    img: "virtualDesktop.svg",
    name: "لود  بالانسر DNS آبالون",
    desc: "با تعریف رکوردهای DNS، می‌توان ترافیک ساب‌دامین‌های مختلف را به‌صورت منعطف میان چند سرور هدایت کرد. این روش کارآمد، سریع و مستقل از پروتکل ارتباطی است.",
    alt: "لود  بالانسر DNS آبالون",
    title: "لود  بالانسر DNS آبالون",
    subtitle: "توزیع بار مبتنی بر رکوردهای DNS",
  },

  {
    img: "test.svg",
    name: "لود بالانسر HTTP آبالون",
    desc: "با اعمال قوانین مسیریابی روی دامنه یا هر URL خاص، ترافیک کاربران میان سرورهای پاپ‌سایت در شبکه CDN توزیع می‌شود. این مدل برای سرویس‌های مبتنی بر وب ایده‌آل است.",
    alt: "لود بالانسر HTTP آبالون",
    title: "لود بالانسر HTTP آبالون",
    subtitle: "توزیع بار از طریق پروتکل HTTP",
  },
  {
    img: "backup.svg",
    name: "لود بالانسر ابری آبالون",
    desc: "ترافیک ارسالی به سمت ماشین‌های مجازی یا سرورهای شما در هر جای جهان را بر اساس IP توزیع می‌کند. این مدل مناسب سازمان‌هایی است که قصد دارند ترافیک را بدون وابستگی به دامنه انتقال دهند.",
    alt: "لود بالانسر ابری آبالون",
    title: "لود بالانسر ابری آبالون",
    subtitle: "توزیع بار بر اساس IP و پروتکل‌های شبکه",
  },
];

export const solotionTabItems = [
  {
    title: "مدیریت ترافیک به کمک رکورد DNS",
    img: "cdn/Feature-8.svg",
    imgAlt: "مدیریت ترافیک به کمک رکورد DNS آبالون",
    imgTitle: "مدیریت ترافیک به کمک رکورد DNS آبالون",
    img_deactive: "cdn/Feature-8.svg",
    section_title: "مدیریت ترافیک به کمک رکورد DNS",
    caption:
      "برای توزیع بار میان چند سرور، بدون نیاز به زیرساخت پیچیده یا تنظیمات فنی سنگین، لود بالانسر DNS آبالون راهکاری ایده‌آل است. تنها با تعریف رکوردهای دامنه، می‌توان ترافیک هر ساب‌دامین را به‌صورت خودکار میان چند سرور هدایت کرد. این مدل، با صرف هزینه‌ای مقرون‌به‌صرفه، پایداری بالا و کارایی مطمئنی را در اختیار می‌گذارد.",
    contentImg: "cdn/CDN-Header.svg",
    contentImgAlt: "مدیریت ترافیک به کمک رکورد DNS آبالون",
    contentImgTitle: "مدیریت ترافیک به کمک رکورد DNS آبالون",
    link: "/vpc",
    alt: "سرویس دیتاسنتر ابری آبالون",
    contentItem: [
      {
        name: "پشتیبانی از رکوردهای متنوع شامل A ،AAAA ،CNAME ،MX ،NS و...",
        img: "/uptime.svg",
        alt: "پشتیبانی از رکوردهای متنوع شامل A ،AAAA ،CNAME ،MX ،NS و...",
        title: "پشتیبانی از رکوردهای متنوع شامل A ،AAAA ،CNAME ،MX ،NS و...",
      },
      {
        name: "پشتیبانی از الگوریتم‌های مسیریابی مختلف مانند Round-Robin و تک سروری",
        img: "/atactks.svg",
        alt: "پشتیبانی از الگوریتم‌های مسیریابی مختلف مانند Round-Robin و تک سروری",
        title:
          "پشتیبانی از الگوریتم‌های مسیریابی مختلف مانند Round-Robin و تک سروری",
      },
      {
        name: "تعیین مسیر ترافیک بر اساس پورت، پروتکل، وزن یا محل جغرافیایی سرورها",
        img: "/geography.svg",
        alt: "تعیین مسیر ترافیک بر اساس پورت، پروتکل، وزن یا محل جغرافیایی سرورها",
        title:
          "تعیین مسیر ترافیک بر اساس پورت، پروتکل، وزن یا محل جغرافیایی سرورها",
      },
      {
        name: "امکان اتصال به CDN برای افزایش سرعت پاسخ‌گویی و امنیت بیشتر",
        img: "/customer.svg",
        alt: "امکان اتصال به CDN برای افزایش سرعت پاسخ‌گویی و امنیت بیشتر",
        title: "امکان اتصال به CDN برای افزایش سرعت پاسخ‌گویی و امنیت بیشتر",
      },
    ],
  },
  {
    title: "مدیریت ترافیک به کمک CDN",
    img: "cdn/Feature-5.svg",
    imgAlt: "مدیریت ترافیک به کمک CDN",
    imgTitle: "مدیریت ترافیک به کمک CDN",
    img_deactive: "cdn/Feature-5.svg",
    section_title: "مدیریت ترافیک به کمک CDN",
    caption:
      "اگر به‌دنبال توزیع دقیق درخواست‌های کاربران از هر آدرس URL برای وب‌سایت‌ها و وب‌اپلیکیشن‌هایتان هستید، لود بالانسر HTTP آبالون یک راهکار حرفه‌ای با قابلیت تنظیمات متعدد است. این سرویس با عبور ترافیک از شبکه CDN، امکان مدیریت مسیر ترافیک بر اساس دامنه، مسیر URL ،IP کاربر یا پروتکل (HTTP/HTTPS) را به شما می‌دهد و از الگوریتم‌هایی مانند Round-Robin یا Client IP Hash برای توزیع بهینه استفاده می‌کند. مزیت کلیدی این راهکار، پایش مستمر سلامت سرورها است؛ به‌طوری که در صورت بروز مشکل، سرور معیوب به‌طور خودکار از چرخه پاسخ‌گویی خارج می‌شود.",
    contentImg: "ManagedService/section-header.svg",
    contentImgAlt: "مدیریت ترافیک به کمک CDN",
    contentImgTitle: "مدیریت ترافیک به کمک CDN",
    link: "/vps",
    alt: "سرویس سرور ابری آبالون",
    contentItem: [
      {
        name: "توزیع ترافیک با مدل‌های Active-Active یا Active-Passive",
        img: "/ssl.svg",
        alt: "توزیع ترافیک با مدل‌های Active-Active یا Active-Passive",
        title: "توزیع ترافیک با مدل‌های Active-Active یا Active-Passive",
      },
      {
        name: "پروتکل ارتباط با سرور از طریق HTTP و HTTPS با امکان حفظ ارتباط‌های Stateful",
        img: "/seo.svg",
        alt: "پروتکل ارتباط با سرور از طریق HTTP و HTTPS با امکان حفظ ارتباط‌های Stateful",
        title:
          "پروتکل ارتباط با سرور از طریق HTTP و HTTPS با امکان حفظ ارتباط‌های Stateful",
      },
      {
        name: "اطلاع رسانی خطای سرور و خروج خودکار آن از مدار توزیع",
        img: "/price.svg",
        alt: "اطلاع رسانی خطای سرور و خروج خودکار آن از مدار توزیع",
        title: "اطلاع رسانی خطای سرور و خروج خودکار آن از مدار توزیع",
      },
      {
        name: "حفظ اتصال پایدار (Keep Alive) برای کاهش بار روی سرور",
        img: "/cms.svg",
        alt: "حفظ اتصال پایدار (Keep Alive) برای کاهش بار روی سرور",
        title: "حفظ اتصال پایدار (Keep Alive) برای کاهش بار روی سرور",
      },
    ],
  },
  {
    title: "مدیریت ترافیک با IP-Based Load Balancing",
    img: "cdn/Feature-1.svg",
    imgAlt: "مدیریت ترافیک در زیرساخت‌های ابری با IP-Based Load Balancing",
    imgTitle: "مدیریت ترافیک در زیرساخت‌های ابری با IP-Based Load Balancing",
    section_title: "کد زدن و آزمون و خطا از شما، زیرساخت و پشتیبانی از ما!    ",
    img_deactive: "cdn/Feature-1.svg",
    caption:
      "لود بالانسر ابری آبالون، یک راهکار ایده‌آل برای توزیع هوشمند ترافیک شبکه در محیط‌های VPC است که با تمرکز بر آدرس‌های IP عمومی و خصوصی، عملکرد بی‌نقصی در مدیریت ترافیک شما فراهم می‌آورد. این سرویس با توزیع بار بین ماشین‌های مجازی و سرورهای موجود در دیتاسنترهای داخلی و یا بین‌المللی، حتی ترافیک اپلیکیشن‌های Stateful را نیز به‌طور مؤثر مدیریت می‌کند.",
    contentImg: "rebranding/pages/VPC-Main.b1c5b7f.svg",
    contentImgAlt:
      "مدیریت ترافیک در زیرساخت‌های ابری با IP-Based Load Balancing",
    contentImgTitle:
      "مدیریت ترافیک در زیرساخت‌های ابری با IP-Based Load Balancing",
    link: "/paas",
    alt: "سرویس پلتفرم ابری آبالون",
    contentItem: [
      {
        name: " دسترسی همیشگی به محتوا",
        img: "/access.svg",
        alt: "دسترسی همیشگی به محتوا با خرید CDN",
        title: "دسترسی همیشگی به محتوا با خرید CDN",
      },
      {
        name: "پشتیبانی از SSL/TLS Termination برای ارتباط امن",
        img: "/ddosAtacks.svg",
        alt: "پشتیبانی از SSL/TLS Termination برای ارتباط امن",
        title: "پشتیبانی از SSL/TLS Termination برای ارتباط امن",
      },
      {
        name: "پشتیبانی از API برای مدیریت پیکربندی ",
        img: "/domainss.svg",
        alt: "پشتیبانی از API برای مدیریت پیکربندی ",
        title: "پشتیبانی از API برای مدیریت پیکربندی ",
      },
      {
        name: "پشتیبانی از الگوریتم‌های Round-Robin و Source IP Hash",
        img: "/speed.svg",
        alt: "پشتیبانی از الگوریتم‌های Round-Robin و Source IP Hash",
        title: "پشتیبانی از الگوریتم‌های Round-Robin و Source IP Hash",
      },
      {
        name: "امکانات پیشرفته مانند Connection Limit و Client Data Timeout",
        img: "/speed.svg",
        alt: "امکانات پیشرفته مانند Connection Limit و Client Data Timeout",
        title: "امکانات پیشرفته مانند Connection Limit و Client Data Timeout",
      },
    ],
  },
];

export const popularServices = [
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری امکانات یک دیتاسنتر فیزیکی قوی را روی ابرها فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌‌ترین نیازهای سازمان شما باشد.",
    logo: "VPC-Service.svg",
    route: "/vpc",
  },
  {
    title: "شبکه توزیع محتوا (CDN)",
    desc: "با استفاده از CDN، امنیت و سرعت بارگذاری وب‌سایت خود را بهبود دهید. داده‌های شما از طریق سرورهای توزیع‌شده همیشه نزدیک‌تر به کاربران خواهند بود.",
    logo: "CloudGuard-Service.svg",
    route: "/cdn",
  },
  {
    title: "سرور اختصاصی",
    desc: "با خرید سرور اختصاصی آبالون، به منابع سخت‌افزاری قدرتمند در دیتاسنترهای پیشرفته سراسر کشور به‌صورت Bare Metal یا با معماری ابری دسترسی داشته باشید.",
    logo: "VPS-Service.svg",
    route: "/dedicated-server",
  },
  {
    title: "سرویس کولوکیشن",
    desc: "با سرویس کولوکیشن آبالون، بدون دغدغه تامین برق، کولینگ و پهنای باند، سرورهای سازمان شما در محیطی ایمن، با اتصال مستقیم به شبکه‌ای پرسرعت میزبانی می‌شوند.",
    logo: "ManagedService-Service.svg",
    route: "/colocation",
  },
];

export const questions = [
  {
    title: "تفاوت انواع لود بالانسر آبالون در چیست؟",
    answer:
      "آبالون سه مدل لود بالانسر DNS، مبتنی بر HTTP و ابری (VPC) ارائه می‌دهد که هرکدام متناسب با نیازهای مختلف زیرساختی و عملیاتی مانند نوع ترافیک، مکان سرورها و الگوریتم‌های مسیریابی انتخاب می‌شوند.",
  },
  {
    title:
      "آیا لود بالانسر ابری آبالون برای سرورهای خارج از دیتاسنتر هم قابل استفاده است؟",
    answer:
      "بله، لود بالانسر ابری آبالون می‌تواند ترافیک را بین ماشین‌های مجازی یا سرورهای دارای IP عمومی یا خصوصی در هر نقطه از ایران یا جهان توزیع کند.",
  },
  {
    title:
      "آیا امکان استفاده از الگوریتم‌های سفارشی برای توزیع ترافیک وجود دارد؟",
    answer:
      "بله، لود بالانسرهای آبالون از الگوریتم‌های متنوعی مثل Round-Robin و Source IP Hash پشتیبانی می‌کنند و امکان تنظیم سیاست‌های سفارشی بر اساس نیاز اپلیکیشن‌های Stateful یا Stateless وجود دارد.",
  },
  {
    title: "قابلیت SSL/TLS Termination در لود بالانسر چه کاربردی دارد؟",
    answer:
      "با این قابلیت، ارتباط امن کاربران در لایه لود بالانسر پایان می‌یابد و ترافیک به صورت دیکریپت شده به سمت سرورهای اصلی ارسال می‌شود که باعث کاهش بار پردازشی سرورها و بهبود عملکرد می‌شود.",
  },
  {
    title:
      "اگر یکی از سرورها یا مسیرها دچار مشکل شود، چه اتفاقی برای ترافیک می‌افتد؟",
    answer:
      "با بهره‌گیری از قابلیت مسیریابی هوشمند و مانیتورینگ سلامت سرورها، لود بالانسر آبالون به‌طور خودکار سرور یا مسیر جایگزین را انتخاب می‌کند تا ارتباط بدون قطعی برای کاربران حفظ شود.",
  },
];
